import ProductPage from "../../components/ProductPage";
import { mutualFundData } from "../../data/productsData";
export default function MutualFund() { return <ProductPage data={mutualFundData} />; }